import { useCallback } from 'react';

import { useDeleteCommunityPostComment } from '@/hooks/react-query/community/comment';
import { usePostCommunityCommentLike } from '@/hooks/react-query/community/like';
import { sendLog } from '@/lib/utils/send-log';

export function useDeleteComment({
  commentId,
  postId,
}: {
  commentId: string;
  postId: string;
}) {
  const { mutate: deleteComment, isPending } = useDeleteCommunityPostComment({
    commentId,
    postId,
  });

  function handleDelete() {
    /**
     * @todo community 이미 삭제되었을 경우 에러 메시지 띄우기
     */
    deleteComment({ commentId });
  }

  return { handleDelete, isPending };
}

export function useLikeComment({
  commentId,
  postId,
}: {
  commentId: string;
  postId: string;
}) {
  const { mutate: like } = usePostCommunityCommentLike({
    postId,
    commentId,
  });

  const handleClickLike = useCallback(() => {
    like(
      { commentId },
      {
        onSuccess: () => {
          sendLog('hh_community_post_comment_like', {
            post_id: postId,
            comment_id: commentId,
            type: '댓글',
          });
        },
      },
    );
  }, [like, postId, commentId]);

  return { handleClickLike };
}
